module.exports = __webpack_public_path__ + "img/6.6b71f2f3.jpg";